/** Tastetegnet på knappene i køkortene (Oppdag). */
export default function QueueKbd({ children }: { children: string }) {
  return (
    <kbd className="ml-2 rounded border border-current/30 px-1 text-[11px] leading-4 opacity-70" aria-hidden>
      {children}
    </kbd>
  );
}
